<template>
  <div>
    <div class="container-fluid mt-4">
      <div class="row">
        <div class="col-xl-3 col-md-6">
          <stats-card
            title="Courses"
            type="gradient-red"
            :sub-title="stat.coursecount"
            icon="ni certificate"
          >
            <template slot="footer">
              <span class="text-success mr-2">{{stat.coursemonthcount}}</span>
              <span class="text-nowrap">Since last month</span>
            </template>
          </stats-card>
        </div>
        <div class="col-xl-3 col-md-6">
          <stats-card
            title="students"
            type="gradient-orange"
            :sub-title="stat.studentcount"
            icon="ni reading"
          >
            <template slot="footer">
              <span class="text-success mr-2">{{stat.studentmonthcount}}</span>
              <span class="text-nowrap">Since last month</span>
            </template>
          </stats-card>
        </div>
        <div class="col-xl-3 col-md-6">
          <stats-card
            title="Teachers"
            type="gradient-green"
            :sub-title="stat.teachercount"
            icon="ni presentation"
          >
            <template slot="footer">
              <span class="text-success mr-2">{{stat.teachermonthcount}}</span>
              <span class="text-nowrap">Since last month</span>
            </template>
          </stats-card>
        </div>
        <div class="col-xl-3 col-md-6">
          <stats-card
            title="Classes"
            type="gradient-info"
            :sub-title="stat.classcount"
            icon="ni show-room"
          >
            <template slot="footer">
              <span class="text-success mr-2">{{stat.classmonthcount}}</span>
              <span class="text-nowrap">Since last month</span>
            </template>
          </stats-card>
        </div>
      </div>

      <div class="row">
        <div class="col-xl-6">
          <card>
            <h5 class="h3 mb-0" slot="header">Class Progress track</h5>
            <ul class="list-group list-group-flush list my--3">
              <li class="list-group-item px-0" v-for="item in classes" :key="item.id">
                <div class="row align-items-center">
                  <div class="col-auto">
                    <img
                      :src="item.picture=== null ? nophoto : fileurl + item.picture"
                      class="avatar rounded-circle mr-3"
                    />
                  </div>
                  <div class="col">
                    <h5>{{item.code}}. {{item.coursetitle}}</h5>
                    {{item.resppersonname}}
                    <base-progress class="mb-0" type="green" :value="item.progress"></base-progress>
                    <span
                      style="font-size: 12px"
                    >{{item.progress}}% ({{item.finishedlessoncount}} of {{item.totallessoncount}})</span>
                  </div>
                  <div class="col-auto">
                    <base-button type="primary" size="sm" @click="openClass(item)">Open</base-button>
                  </div>
                </div>
              </li>
            </ul>
          </card>
        </div>
        <div class="col-xl-6">
          <card>
            <h5 class="h3 mb-0" slot="header">Awaiting lessons (2 weeks)</h5>
            <ul class="list-group list-group-flush list my--3">
              <li class="list-group-item px-0" v-for="item in lessons" :key="item.id">
                <div
                  class="checklist-item"
                  :class="{'checklist-item-checked': false, 'checklist-item-danger': item.rmnddays < 2}"
                >
                  <div class="row align-items-center">
                    <div class="col-lg-10">
                      <span>{{rmndname(item)}}</span>
                      <table>
                        <tr>
                          <td>
                            <span style="font-size: 14px">{{item.lessondatestr}}</span>
                          </td>
                          <td valign="middle">
                            <span style="font-size: 12px">+ {{item.duration}} minutes</span>
                          </td>
                        </tr>
                      </table>

                      <h5>{{item.classcode}}. {{item.coursetitle}}</h5>
                      <span
                        style="font-size: 12px"
                      >{{item.teachername}}, {{item.locationtypename}} {{item.locationtype === 2 ? item.location : ''}}</span>
                    </div>
                    <div class="col-lg-1">
                      <base-button type="primary" size="sm" @click="openLesson(item)">Open</base-button>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { GetStat } from "../../../services/stat";
import { GetClasses, GetSchedule } from "../../../services/classes";
import { nophoto, fileUrl, DateToString, DateTimeToString } from "../../../services/helper";
export default {
  data() {
    return {
      stat: {},
      classes: [],
      lessons: [],
    };
  },
  methods: {
    openClass(item) {
      this.$router.push({ path: "/class/" + item.id }).catch((e) => {});
    },

    openLesson(item) {
      this.$router.push({ path: "/lesson/" + item.id }).catch((e) => {});
    },

    rmndname(item) {
      let today = new Date();
      let dt = new Date(item.lessondate);
      if (item.rmnddays === 0 && today.getDay() === dt.getDay()) {
        return "Today";
      } else if (item.rmnddays === 1 || item.rmnddays === 0) {
        return "Tomorrow";
      } else {
        return "After " + item.rmnddays.toString() + " days";
      }
    },
  },
  computed: {
    fileurl() {
      return fileUrl;
    },
    nophoto() {
      return nophoto;
    },
  },
  mounted() {
    GetStat().then((response) => {
      if (response.data.result) {
        this.stat = response.data.result;
      }
      console.log(response.data)
    });
    GetClasses(1).then((response) => {
      if (response.data.result) {
        this.classes = response.data.result;
      } else this.classes = [];
    });
    let filter = {
      start: new Date(),
      end: new Date(),
      searchtype: 1,
      id: "",
    };
    filter.end = DateToString(new Date(filter.end.setDate(filter.end.getDate() + 14)));
    filter.start = DateTimeToString(filter.start);
    GetSchedule(filter).then((response) => {
      if (response.data.result) {
        this.lessons = response.data.result;
      } else {
        this.lessons = [];
      }
    });
  },
};
</script>